import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate'
import {
  alpha_dash,
  alpha_num,
  alpha_spaces,
  between,
  confirmed,
  digits,
  dimensions,
  email,
  excluded,
  ext,
  image,
  oneOf,
  integer,
  length,
  max,
  max_value,
  mimes,
  min,
  min_value,
  numeric,
  regex,
  required,
  required_if,
  size
}
from 'vee-validate/dist/rules' // 验证规则导入

localize('zh_CN', {
  name: 'zh_CN',
  messages: {
    // your messages.
    "alpha": "{_field_}只能包含字母字符",
    "alpha_dash": "{_field_}能够包含字母数字字符、破折号和下划线",
    "alpha_num": "{_field_}只能包含字母数字字符",
    "alpha_spaces": "{_field_}只能包含字母字符和空格",
    "between": "{_field_}必须在{min}与{max}之间",
    "confirmed": "{_field_}不能和{target}匹配",
    "digits": "{_field_}必须是数字，且精确到{length}位数",
    "dimensions": "{_field_}必须在{width}像素与{height}像素之间",
    "email": "{_field_}不是一个有效的邮箱",
    "excluded": "{_field_}不是一个有效值",
    "ext": "{_field_}不是一个有效的文件",
    "image": "{_field_}不是一张有效的图片",
    "oneOf": "{_field_}不是一个有效值",
    "integer": "{_field_}必须是整数",
    "length": "{_field_}长度必须为{length}",
    "max": "{_field_}不能超过{length}个字符",
    "max_value": "{_field_}必须小于或等于{max}",
    "mimes": "{_field_}不是一个有效的文件类型",
    "min": "{_field_}必须至少有{length}个字符",
    "min_value": "{_field_}必须大于或等于{min}",
    "numeric": "{_field_}只能包含数字字符",
    "regex": "{_field_}格式无效",
    "required": "{_field_}是必须的",
    "required_if": "{_field_}是必须的",
    "size": "{_field_}必须小于{size}KB"
  }
})

extend('alpha_dash', alpha_dash)
extend('alpha_num', alpha_num)
extend('alpha_spaces', alpha_spaces)
extend('between', between)
extend('confirmed', confirmed)
extend('digits', digits)
extend('dimensions', dimensions)
extend('email', email)
extend('excluded', excluded)
extend('ext', ext)
extend('image', image)
extend('oneOf', oneOf)
extend('integer', integer)
extend('length', length)
extend('max', max)
extend('max_value', max_value)
extend('mimes', mimes)
extend('min', min)
extend('min_value', min_value)
extend('numeric', numeric)
extend('regex', regex)
extend('required', required)
extend('required_if', required_if)
extend('size', size)

// ********************新增规则******************************
// 手机号码验证
extend('mobile', {
  message: () => `请输入正确的手机号码`,
 // validate: value => value.length === 11 && /^(((13[0-9]{1})|(14[57]{1})|(15[012356789]{1})|(17[03678]{1})|(18[0-9]{1})|(19[89]{1})|(16[6]{1}))+\d{8})$/.test(value)
 validate: value => value.length === 11 && /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(value)

})
// 设置
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)



// WEBPACK FOOTER //
// ./src/box/validator.js